import React, { Component } from 'react';

import { Button } from '@vds/buttons';
import { Line } from '@vds/lines';
import { Body } from '@vds/typography';
import { RadioButtonGroup } from '@vds/inputs';
import { spacers } from '@vds/theme';
import map from 'lodash/map';
import styled from 'styled-components';
import './AddressConfirmation.css';

const MarginSpacerTopL = styled.div`margin-top: ${spacers.large} !important;`;

const StreetLine1 = styled(Line)`
margin-top: ${spacers.large} !important;
margin-bottom: ${spacers.large} !important;
`;

const StreetLine2 = styled(Line)`
margin-bottom: ${spacers.large} !important;
`;


class AddressConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [
                {
                    name: 'group',
                    children: 'No, I want to re-enter my address.',
                    value: 'reEnter',
                    ariaLabel: 'Re Enter',
                },
                {
                    name: 'group',
                    children: 'I can`t find my address',
                    value: 'cantfind',
                    ariaLabel: 'Cant Fine'
                }
            ]
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    multipleAddressList = () => {
        let list = this.props.streetAddressSuggestionList ? this.props.streetAddressSuggestionList : [];
        list = list.map(street => {

            let radioObj = {};
            radioObj.name = 'group';
            radioObj.children = `${street.ZipCode},  ${street.CommunityName},  ${street.ParsedRawString}`;
            radioObj.value = street.ParsedRawString;
            radioObj.ariaLabel = "";
            return radioObj
        })
        return list
    }

    getSectionalAddress = () => {
        let list = this.props.streetAddressSuggestionList ? this.props.streetAddressSuggestionList : [];
        let streetMap = {};
        map(list, street => {
            const streetAddr = street.ParsedRawString?.trim().split(street.UnitType)[0];
            if(!streetMap[streetAddr]) {
                streetMap[streetAddr] = [];
            }
            streetMap[streetAddr].push(street);
        })

        const radioList = (
            <div className="multiple-addr-list">
                    {map(streetMap, (strObArr, key) => { 
                        return   ( 
                            <div>
                                <div className="section-header">{key}</div>
                                <RadioButtonGroup className="radioFont"
                                    onChange={(e) => this.props.multipleAddrRadioClick(e)}
                                    data={strObArr.map(street => {
                                        let radioObj = {};
                                        radioObj.name = 'group';
                                        radioObj.children = `${street.ZipCode},  ${street.CommunityName},  ${street.ParsedRawString}`;
                                        radioObj.value = street.ParsedRawString;
                                        radioObj.ariaLabel = "";
                                        return radioObj
                                })} />
                            </div>);
                    })}
            </div>
        ); 
        return radioList;
    }

    render() {
        const { data } = this.state;
        const addressOptions = this.multipleAddressList();
        return (
            <MarginSpacerTopL>
                <Body size="medium" primitive="p" bold={true}>
                    Do you see your street address below ?
                </Body>
                <StreetLine1 type="light" />
                <RadioButtonGroup className="radioFont"
                    onChange={(e) => this.props.multipleAddrRadioClick(e)}
                    data={addressOptions}
                />
                <StreetLine2 type="light" noMargin />
                <RadioButtonGroup className="radioFont"
                    onChange={(e) => this.props.multipleAddrRadioClick(e)}
                    data={data}
                />
                {/* {this.getSectionalAddress()} */}
                {/* <div className="check-availability-button">
                    <Button onClick={() => this.props.triggerAddressQualification(this.props.history)} >Back to Check Availability</Button>
                </div> */}
            </MarginSpacerTopL>
        );
    }
}

export default AddressConfirmation;